module.exports = __webpack_public_path__ + "static/redshift-a47002f7c53838b412acee4075468892.jpg";